import React from 'react'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../components/Common/CellText'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import utils from '../../utils'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import { Col, Row, Tag } from 'antd'
import { AvatarHasName } from '../../components/Common/Avatar'
import { KeyValueItem } from '../../components/Common/KeyValueItem'

const InfoWrapper = styled.div`
  .info-row {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    .info-label {
      font-weight: 700;
      flex: 0 0 120px;
      width: 100px;
    }
    .user-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      .user {
        border-radius: 35px;
        padding: 3px 8px 3px 4px;
        display: flex;
        margin-right: 0;
        align-items: center;
      }
    }
  }
  .last-row {
    margin-bottom: 0;
  }
`

const ProposalAdvanceInfo = props => {
  const { className, proposalAdvanceStore } = props

  const { proposalAdvanceDetail } = proposalAdvanceStore

  return (
    <div className="custom-create-page-content-wrapper">
      <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
        Thông tin chung
      </h3>

      <Row gutter={[20, 20]}>
        <Col span={12}>
          <KeyValueItem
            label="Tiêu đề"
            value={
              proposalAdvanceDetail.title || (
                <EmptyText>Không có tiêu đề.</EmptyText>
              )
            }
          />
        </Col>
        <Col span={12}>
          <KeyValueItem
            label="Nội dung"
            value={
              proposalAdvanceDetail.content ? (
                WordBreak(proposalAdvanceDetail.content, true)
              ) : (
                <EmptyText>Không có nội dung.</EmptyText>
              )
            }
          />
        </Col>
        <Col span={12}>
          <KeyValueItem
            label="Tài liệu đính kèm"
            value={
              proposalAdvanceDetail.attachments &&
              proposalAdvanceDetail.attachments.length > 0 ? (
                proposalAdvanceDetail.attachments.map(file => (
                  <FileItem
                    key={file.file_id}
                    file_id={file.file_id}
                    file_name={file.file_name}
                    file_type={utils.getExtensionFile(file.file_name)}
                  />
                ))
              ) : (
                <EmptyText>Không có tài liệu đính kèm.</EmptyText>
              )
            }
          />
        </Col>
        <Col span={12}>
          <KeyValueItem
            label="Người theo dõi"
            value={
              proposalAdvanceDetail.followers &&
              proposalAdvanceDetail.followers.length > 0 ? (
                proposalAdvanceDetail.followers.map(el => (
                  <Tag
                    className={'user'}
                    color={'blue'}
                    key={el.user_name}
                    style={{
                      borderRadius: 4,
                    }}>
                    {el.name_uppercase}
                  </Tag>
                ))
              ) : (
                <EmptyText>Không có người theo dõi.</EmptyText>
              )
            }
          />
        </Col>
      </Row>
    </div>
  )
}

ProposalAdvanceInfo.propTypes = {}

export default inject('proposalAdvanceStore')(observer(ProposalAdvanceInfo))
